import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';
import { Header } from '@components/Header/Header';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  includeHeader?: boolean;
  includeFooter?: boolean;
};
// lazy load the footer since it is always below the fold for opt
const FooterDynamic = dynamic(() =>
  import('../../components/Footer/Footer').then((mod) => mod.Footer)
);

const StandardLayout: FC<Props> = ({
  children,
  includeHeader = true,
  includeFooter = true,
}) => {
  return (
    <>
      {includeHeader && <Header />}
      <BulkErrorBoundary location="Layout wrapper">
        {children}
      </BulkErrorBoundary>
      {includeFooter && <FooterDynamic />}
    </>
  );
};

const StandardLayoutNoIndex: FC<Props> = ({
  children,
  includeHeader = true,
  includeFooter = true,
}) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      {includeHeader && <Header />}
      <BulkErrorBoundary location="Layout wrapper">
        {children}
      </BulkErrorBoundary>
      {includeFooter && <FooterDynamic />}
    </>
  );
};

export { StandardLayout, StandardLayoutNoIndex };
